import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const Sidebar: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <aside className="cmn-chem-sidebar">
      <div className="cmn-chem-sidebar__header">
        <i
          className="bi bi-chevron-double-left cmn-chem-sidebar__icon"
          onClick={() => history.push('/enviro-chemical-ai')}
          data-tip="Go back"
          data-for="back-tooltip"
        />
      </div>
      <div className="cmn-chem-sidebar__content">
        <button
          type="button"
          className={`cmn-chem-sidebar__item${isActive('/enviro-chemical-ai/new-chemical-review') ? ' is-active' : ''}`}
          onClick={() => history.push('/enviro-chemical-ai/new-chemical-review')}
        >
          New Chemical Review
        </button>
        <button
          type="button"
          className="cmn-chem-sidebar__item"
          onClick={() => {
            // TODO: Navigate to Chemical Substitution Analysis page
          }}
        >
          Chemical Substitution Analysis
        </button>
        <button
          type="button"
          className="cmn-chem-sidebar__item"
          onClick={() => {
            // TODO: Navigate to Exposure Assessment page
          }}
        >
          Exposure Assessment
        </button>
        <button
          type="button"
          className="cmn-chem-sidebar__item"
          onClick={() => {
            // TODO: Navigate to Waste Characterization page
          }}
        >
          Waste Characterization
        </button>
      </div>
      <ReactTooltip id="back-tooltip" effect="solid" place="right" className="cmn-tooltip-maxw-200" />
    </aside>
  );
};

export default Sidebar;

